import { ToastrService } from 'ngx-toastr';
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
export class NgxToastrService {
    constructor(toastrService) {
        this.toastrService = toastrService;
    }
    success(message) {
        this.toastrService.success(message);
    }
    error(message) {
        this.toastrService.error(message);
    }
    info(message) {
        this.toastrService.info(message);
    }
    warn(message) {
        this.toastrService.warning(message);
    }
}
NgxToastrService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NgxToastrService_Factory() { return new NgxToastrService(i0.ɵɵinject(i1.ToastrService)); }, token: NgxToastrService, providedIn: "root" });
